// extracted by mini-css-extract-plugin
export default {"link":"reset-password_link__vKjAj"};